import { createSlice } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

const initialState = {
    filters: {
        card: {
            equipmentClass: 'forklifts',
        },
        selectedCategory: 'allClasses',
        fuelType: 'All',
        minCapacity: '3000',
        maxCapacity: '10000',
        minHeight: '10',
        maxHeight: '5000',
        deals: false,
        pageNumber: 1,
        pageSize: 12,
        requestUUID: '',
    },
}

const usedEquipmentSlice = createSlice({
    name: 'UsedEquipment',
    initialState,
    reducers: {
        saveUsedEquipmentFilters(state, { payload }) {
            state.filters = payload
        },
        resetUsedEquipmentFilters(state) {
            state.filters = initialState.filters
        },
    },
})

export const { actions } = usedEquipmentSlice
export default usedEquipmentSlice.reducer

export const useUsedEquipmentActions = () => {
    const dispatch = useDispatch()

    const saveUsedEquipmentFilters = filters => {
        return dispatch(actions.saveUsedEquipmentFilters(filters))
    }
    const resetUsedEquipmentFilters = () => {
        return dispatch(actions.resetUsedEquipmentFilters())
    }

    return {
        saveUsedEquipmentFilters,
        resetUsedEquipmentFilters,
    }
}
